<template>
  <div :style="$route.path !== '/authen' ? 'padding: 10px !important;' : ''">
    <v-scale-transition>
      <v-btn
        fab
        v-show="fab"
        v-scroll="onScroll"
        dark
        fixed
        bottom
        right
        color="secondary"
        @click="toTop"
      >
        <v-icon>mdi-arrow-up</v-icon>
      </v-btn>
    </v-scale-transition>

    <!-- normal -->
    <router-view />

    <!-- maintance -->

    <!-- <div style="padding: 50px;width: 100%;" class="text-center">
        <v-alert
          outlined
          color="purple"
        >
          <div class="text-h6 mb-5">
            Scheduled System Maintenance Notification INSTRUCTOR SITE:
          </div>
          <br><br>
          <div>
            <p class="mt-5 mb-0" style="font-size: 20px;font-weight: 300;color: #000000">Dear Faculty,</p>
            <br>
            <p class="mt-0 mb-0 ml-5" style="font-size: 20px;font-weight: 900;color: #000000">
              We would like to inform you that our IT system will undergo scheduled maintenance to enhance its performance and reliability. During this period, the system will be temporarily unavailable.
            </p>
            <br>
            <v-alert
              prominent
              type="error"
              style="background-color: #FF8383 !important;color: #000000 !important;font-weight: 500 !important;font-size: 18px;font-family: 'Sarabun';"
            >
              <v-row align="center">
                <v-col class="grow">
                  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Maintenance Schedule: Expected Completion: Within 24 hours
                </v-col>
              </v-row>
            </v-alert>
            <br>
            <p class="mt-0 mb-0" style="font-size: 18px;font-weight: 300;">
              This maintenance is essential to ensure that our system continues to provide you with the best possible experience. We are committed to completing the process as quickly as possible and minimizing any inconvenience.
            </p>
            <br>
            <p class="mt-0 mb-0" style="font-size: 18px;font-weight: 300;">
              We appreciate your understanding and patience during this time. Should you have any questions or require assistance, please feel free to contact our support team  
            </p>
            <br>
            <p class="mt-0 mb-0" style="font-size: 18px;font-weight: 300;">Thank you for your understanding and cooperation.</p><br><br>
            <p class="mt-0 mb-0" style="font-size: 18px;font-weight: 300;">Best regards,</p>
            <br>
            <p class="mt-0 mb-0" style="font-size: 18px;font-weight: 300;">Information Technology Section</p>
            <br>
            <p class="mt-0 mb-0" style="font-size: 18px;font-weight: 300;">Mahidol University International College</p>
          </div>
        </v-alert>
      </div> -->
  </div>
</template>

<script>
export default {
  name: "App",
  data() {
    return {
      fab: null,
    };
  },
  created() {
    const top = window.pageYOffset || 0;
    if (top <= 60) {
      this.color = "transparent";
      this.flat = true;
    }
  },
  watch: {
    fab(value) {
      if (value) {
        this.color = "secondary";
        this.flat = false;
      } else {
        this.color = "transparent";
        this.flat = true;
      }
    },
  },
  methods: {
    onScroll(e) {
      if (typeof window === "undefined") return;
      const top = window.pageYOffset || e.target.scrollTop || 0;
      this.fab = top > 60;
    },
    toTop() {
      this.$vuetify.goTo(0);
    },
  },
};
</script>
